import { Injectable } from '@angular/core';
import { Loader } from '@googlemaps/js-api-loader';

@Injectable({
  providedIn: 'root'
})
export class GoogleMapsService {
  private loader: Loader;

  constructor() {
    this.loader = new Loader({
      apiKey: 'AIzaSyA1MJ2M9dGMpKZ7ipdb2rRl2LpfaKzgPUY', // Replace with your API key
      version: 'weekly',
      libraries: ['places']
    });
  }

  load(): Promise<typeof google> {
    return this.loader.load(); // This returns a Promise<typeof google>
  }
}
